export function getIsSorted(sortedColumn, directionSort) {
  return sortedColumn === 'email' ? directionSort : null;
}
